exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control--3ySQ3 {\n  max-width: 260px;\n}\n\n.modal--2qY_M {\n  max-width: 600px;\n}\n\n.modal-content--wSp6A {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.inputs--tlyfw {\n  max-width: 380px;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.summary--2PbZ2 {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.submit--1l4cM {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.submit--1l4cM .button--3YjiK {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"control": "control--3ySQ3",
	"modal": "modal--2qY_M",
	"modal-content": "modal-content--wSp6A",
	"inputs": "inputs--tlyfw",
	"summary": "summary--2PbZ2",
	"submit": "submit--1l4cM",
	"button": "button--3YjiK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-admin/Users/CreateProcUser/CreateUser.m.scss
// module id = 1590
// module chunks = 0